/* unplugin-vue-components disabled */import script from "./SelectCouponItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCouponItem.vue?vue&type=script&setup=true&lang=js"

import "./SelectCouponItem.vue?vue&type=style&index=0&id=065804fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065804fe"]])

export default __exports__